/**
 * @GENERATED from Figma node 3638:51830
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const PagerdutyBright = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#048A24"
      d="M20 2H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M11.427 6.167c1.5 0 2.14.086 3.053.573.993.533 1.607 1.593 1.607 2.913 0 1.227-.5 2.287-1.46 2.92-.88.587-1.88.667-3.214.667H8.047V6.167zM9.76 11.76h2.047c1.433 0 2.526-.573 2.526-2.087 0-1.406-.88-2.02-2.64-2.006L9.76 7.68zm-1.713 2.967H9.76v3.107H8.047z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = React.forwardRef(PagerdutyBright);
export { ForwardRef as PagerdutyBright };
